// eslint-disable-next-line @typescript-eslint/no-explicit-any
type JsonDataObject = { [k: string]: any };

/**
 * Escape slashes and tildes
 *
 * @param str json pointer key
 */
function escape(str: string) {
	return str.toString().replace(/~/g, "~0").replace(/\//g, "~1");
}

/**
 * Unescape slashes and tildes
 *
 * @param str json pointer key
 */
function unescape(str: string) {
	return str.replace(/~1/g, "/").replace(/~0/g, "~");
}

/**
 * Splits up a json pointer into an array of keys. The string is
 * split at each slash, but we ignore the leading slash because
 * all of the data keys coming out of our API have them
 *
 * @param pointer a json pointer
 */
function parse(pointer: string) {
	if (pointer === "") {
		return [];
	}
	if (pointer.charAt(0) !== "/") {
		throw new Error("Invalid JSON pointer: " + pointer);
	}
	return pointer.substring(1).split(/\//).map(unescape);
}

/**
 * Check if data contains a value at location
 * specified by the json pointer
 *
 * @param obj json
 * @param pointer json pointer string
 */
function has(obj: JsonDataObject, pointer: string) {
	try {
		get(obj, pointer);
	} catch (e) {
		return false;
	}
	return true;
}

/**
 * Get a value from json data using a json pointer string
 *
 * @param obj json data
 * @param pointer json pointer string
 */
function get(obj: JsonDataObject, pointer: string): unknown {
	const refTokens = parse(pointer);

	for (let i = 0; i < refTokens.length; ++i) {
		const tok = refTokens[i];
		if (!(typeof obj == "object" && tok in obj)) {
			throw new Error("Invalid reference token: " + tok);
		}
		obj = obj[tok];
	}
	return obj;
}

/**
 * Takes a json pointer and return it formatted
 * to be used as an ID in a query
 */
function pointerToId(pointer: string) {
	try {
		return `data${pointer?.replace(/\//g, ".")}`;
	} catch (err) {
		return pointer;
	}
}

export default {
	has,
	get,
	escape,
	parse,
	pointerToId,
};
